import { useContext } from "react";
import { WebotServerContext } from "../contexts/WebotServerContext";

// ----------------------------------------------------------------------

const useWebotServer = () => useContext(WebotServerContext);

export default useWebotServer;
